/**

  ___                       _      ___       _        
 |   \ _  _ _ _  __ _ _ __ (_)__  |   \ __ _| |_ __ _ 
 | |) | || | ' \/ _` | '  \| / _| | |) / _` |  _/ _` |
 |___/ \_, |_||_\__,_|_|_|_|_\__| |___/\__,_|\__\__,_|
       |__/
       
*/
export interface IPubSubSubscriber {
    identifier: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    notify(msg: string, data?: any): void;
}

export class PubSubManager {
    private notifyList: Map<string, Map<string, IPubSubSubscriber>>;

    constructor() {
        this.notifyList = new Map<string, Map<string, IPubSubSubscriber>>();
    }

    subscribe(msg: string, subscriber: IPubSubSubscriber) {
        let subscribeGroup: Map<string, IPubSubSubscriber>;

        if (this.notifyList.has(msg)) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            subscribeGroup = this.notifyList.get(msg)!;
        } else {
            subscribeGroup = new Map<string, IPubSubSubscriber>();
            this.notifyList.set(msg, subscribeGroup);
        }

        if (subscribeGroup.has(subscriber.identifier)) {
            return;
        } else {
            subscribeGroup.set(subscriber.identifier, subscriber);
        }
    }

    unsubscribe(msg: string, subscriber: IPubSubSubscriber) {
        if (this.notifyList.has(msg)) {
            const subscribeGroup = this.notifyList.get(msg);
            subscribeGroup?.delete(subscriber.identifier);
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    publish(msg: string, data?: any) {
        if (this.notifyList.has(msg)) {
            const subscribeGroup = this.notifyList.get(msg);

            subscribeGroup?.forEach((sub: IPubSubSubscriber, _key: string) => {
                sub.notify(msg, data);
            });
        }
    }
}
